import {
  DomainBranding,
  DomainReference,
  DomainTree,
  Module,
} from '@rygen/rygen-ui/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'domain';

export class DomainController extends BaseHttpController {
  constructor() {
    super(endpoint, { allowNavigations: true });
  }

  async getById(domainId: number): Promise<DomainReference> {
    const response = await this.http.get<DomainReference>(`${domainId}`);
    return new DomainReference(response.data);
  }

  async getTree(): Promise<DomainTree[]> {
    const response = await this.http.get<DomainTree[]>(`tree/${Module.TMS}`);
    return response.data.map((val) => new DomainTree(val));
  }

  async getAllDomains(): Promise<DomainTree[]> {
    const response = await this.http.get<DomainTree[]>('tree');
    return response.data.map((val) => new DomainTree(val));
  }

  async getBranding(domainId: number): Promise<DomainBranding> {
    const response = await this.http.get<DomainBranding>(
      `${domainId}/branding`,
    );
    return new DomainBranding(response.data);
  }
}
